<template>
  <div class="tw:flex tw:flex-col tw:gap-2 tw:border tw:border-default-200 tw:bg-default-000 tw:p-4 tw:rounded-sm">
    <p class="tw:body-1--bold">{{ title }}</p>
    <ReadyFlowsInsightSanitizedContent :content="description" />
  </div>
</template>

<script setup lang="ts">
import ReadyFlowsInsightSanitizedContent from "../ReadyFlowsInsightSanitizedContent.vue";

interface Props {
  title: string;
  description: string | null;
}

defineProps<Props>();
</script>
